import moment from './moment-enhanced.js'

export default /* MomentPlugin */ {

  install(Vue, options) {
    console.log("[EMO] Installing momentPlugin");
    // (function() {
    //   var mmt = 'undefined' !== typeof window ? window.moment : require('moment');
        // const moment = options && options.moment ? options.moment : require('moment');
    //   })();

    if ( options && options.store ) {
      let unwatch = options.store.watch(
        (state, getters) => getters["app/user_get_dateformat"],
        user_timezone => {
          if ( unwatch ) {
            console.log("[EMO] Self destroying watcher");
            unwatch(); // Self destroy
          }
        },
        { immediate: true }
      );
    }

    Object.defineProperties(Vue.prototype, {
      $moment: {
        get() {
          return moment;
        },
      },
    });

    Vue.filter('userDate', momentObj => {
      // TODO: Only works on this machine and only after page reload
      let userFormat = localStorage.getItem('dateformat') || 'LLLL';
      // TODO: Validate
      return momentObj.format(userFormat);
    });

    Vue.filter("shortDate", date => {
      return moment(date).format('ll'); // "Apr 29, 2019"
    })

    Vue.filter("longDate", date => {
      return moment(date).format('LL'); // "April 29, 2019"
    })

    Vue.filter("birthdayDate", date => {
      if ( !moment.isValidDate( date ) ) {
        return null;
      }
      let dateNeutral = date.clone();
      dateNeutral.isTimezoneNeutral = true;
      return moment.fromTimezoneNeutral(dateNeutral).format('LL') // "April 29, 2019" (Timezone neutral)
    })

    Vue.filter("longDateWithDay", date => {
      return moment(date).format('ddd, LL'); // "Monday, April 29, 2019"
    })

    Vue.filter("longDateRange", dateArray => {
      return moment( dateArray[0] ).format('MMMM D') + ' - '
           + moment( dateArray[1] ).format('LL'); // "April 25 - April 29, 2019"
    })

    Vue.filter("shortDateNumeric", time => {
      return moment(time).format('L'); // "04/29/2019"
    })

    Vue.filter("shortTime", time => {
      return moment(time).format('LT'); // "12:00 PM"
    })

    Vue.filter("longTime", date => {
      return moment(date).format("HH:mm:ss");
    })

    Vue.filter("shortDateTime", date => {
      return moment(date).format('LLL'); // "April 29, 2019 12:00 PM"
    })

    Vue.filter("fromNow", date => {
      return moment(date).fromNow();
    })

    Vue.filter("completionDateShort", date => {
      if (moment().format("L") === moment(date).format("L")) { // today
        return 'today, ' + moment(date).format("LT")
      } else if (moment().add(1, 'days').format("L") === moment(date).format("L")) { // tomorrow
        return 'tomorrow, ' + moment(date).format("LT")
      } else if (moment().format("YYYY") === moment(date).format("YYYY")) { // tomorrow
        return moment(date).format("LL").replace(', ' + moment().format("YYYY"),'') + ', ' + moment(date).format("LT")
      } else {
        return moment(date).format("LL") + ', ' + moment(date).format("LT")
      }
    })

    Vue.filter("hours", seconds => {
      let hours = 0;
      if (seconds >= 0) {
        hours = Math.round(seconds / (60 * 60));
        return `${hours}h`;
      }
    })

    Vue.filter("hoursMinutes", seconds => {
      // TODO: Use utils function (D-R-Y)
      let days = 0;
      let hours = 0;
      let min = 0;
      let sign = ''
      if (seconds < 0) {
        sign = '-'
        seconds = Math.abs(seconds)
      }
      if (seconds >= 0) {
        days = 0; // Don't show days
        // days = Math.floor(seconds / (60 * 60 * 24) );
        hours = Math.floor((seconds - days * 60 * 60 * 24) / (60 * 60) );
        min = Math.ceil((seconds - days * 60 * 60 * 24 - hours * 60 * 60) / 60 );
        if (days > 0) {
          return `${sign}${days}d ${hours}h` + (min !== 0 ? ` ${min}min` : '');
        } else if (hours > 0) {
          return `${sign}${hours}h` + (min !== 0 ? ` ${min}min` : '');
        } else {
          return `${sign}${min}min`;
        }
      }
    })

    Vue.filter("hoursMinutesSeconds", seconds => {
      // TODO: Use utils function (D-R-Y)
      let hours = 0;
      let min = 0;
      let sec = 0;
      if (seconds >= 0) {
        hours = Math.floor((seconds) / (60 * 60) );
        min = Math.floor((seconds - hours * 60 * 60) / 60 );
        sec = Math.floor((seconds - hours * 60 * 60 - min * 60) );
        let time = ''
        if (hours >= 10) {
          time += ' ' + hours + 'h'
        } else if (hours > 0 ) {
          time += ' 0' + hours + 'h'
        }
        if (min >= 0) {
          time += ' ' + min + 'm'
        }

        if (sec >= 10) {
          time += ' ' + sec + 's'
        } else if (min >= 0 ) {
          time += ' 0' + sec + 's'
        } else {
          time += ' 0s'
        }
        return time
      } else {
        return `0m 0s`;
      }
    })

    Vue.prototype.$filters = Vue.options.filters // make filter available globally in javascript
  }
}
